module.exports = __webpack_public_path__ + "img/a011.4014c76b.png";